import type { ComponentProps } from 'react';
import styled from 'styled-components';

import { Dropdown } from '#src/atoms/dropdowns/Dropdown/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { NavItem } from '#src/components/navigation/NavItem/index.tsx';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

export const DropdownContent = styled(Horizontal)`
  background-color: var(--c-surface-background);
  padding: var(--half-unit);
`;

const SubNavRoot = styled(Vertical).attrs({ gap: 0.5 })`
  border-radius: var(--intermediate-unit);
  background-color: var(--c-surface-background);
`;

type ItemProps = ComponentProps<typeof NavItem> & {
  subItems?: ItemProps[];
};

export const NavItemWithSubNav = ({
  item,
  level = 0,
}: {
  item: ItemProps;
  level?: number;
}) => {
  const isLaptopAndAbove = useIsLaptop();

  const { subItems, to, ...mainItemProps } = item;
  if (isLaptopAndAbove && !!subItems?.length) {
    if (level > 0) {
      return (
        <>
          <NavItem to={to} {...mainItemProps} />
          <SubNavRoot
            style={{ paddingLeft: `calc(${level} * var(--quadruple-unit))` }}
          >
            {subItems.map(subNavItem => (
              <NavItemWithSubNav
                key={subNavItem.label}
                item={subNavItem}
                level={level + 1}
              />
            ))}
          </SubNavRoot>
        </>
      );
    }
    return (
      <Dropdown
        forceDesktopBehavior
        triggerOnHover
        side="right"
        gap={24}
        label={({ open, ...otherProps }) => (
          <menu {...otherProps} type="menu">
            <li>
              <NavItem to={to} {...mainItemProps} />
            </li>
          </menu>
        )}
      >
        {({ closeDropdown }) => (
          <DropdownContent>
            <SubNavRoot onClick={closeDropdown}>
              {subItems.map(subNavItem => (
                <NavItemWithSubNav
                  key={subNavItem.label}
                  item={subNavItem}
                  level={level + 1}
                />
              ))}
            </SubNavRoot>
          </DropdownContent>
        )}
      </Dropdown>
    );
  }

  return <NavItem to={to} {...mainItemProps} />;
};
